// components/Cart/CartButtons.js
import React, { useState } from 'react';
import styles from '../../ChatApp.module.css';
import { CartIcon, CloseIcon, DraftIcon } from '../../utils/AppHelpers';
import ShoppingCart from './ShoppingCart';
import DraftItems from './DraftItems';

export const FloatingCartButton = ({ itemCount, onClick }) => {
    return (
        <button className={styles.floatingCartButton} onClick={onClick}>
            <CartIcon />
            {itemCount > 0 && <span className={styles.cartItemCount}>{itemCount}</span>}
        </button>
    );
};

export const CartModal = ({ cart, isOpen, onClose, onUpdateQuantity, onRemoveItem, onImageClick, onCheckout }) => {
    if (!isOpen) return null;
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };
    return (
        <div className={styles.cartModalOverlay} onClick={handleOverlayClick}>
            <div className={styles.cartModalContent}>
                <div className={styles.cartModalHeader}>
                    <h3 className={styles.cartHeader}><CartIcon style={{marginRight: '8px'}}/> Shopping Cart</h3>
                    <button className={styles.cartModalCloseButton} onClick={onClose}><CloseIcon /></button>
                </div>
                <div className={styles.cartModalBody}>
                    <ShoppingCart
                        cart={cart}
                        onUpdateQuantity={onUpdateQuantity}
                        onRemoveItem={onRemoveItem}
                        onImageClick={onImageClick}
                        onCheckout={onCheckout}
                    />
                </div>
            </div>
        </div>
    );
};

// --- Sidebar Composite Component ---
export const SidebarCart = ({ cart, onUpdateQuantity, onRemoveItem, onImageClick, onCheckout, onParseDraft }) => {
    const [sidebarTab, setSidebarTab] = useState('cart'); 

    return (
        <div className={styles.sidebar}>
            <div style={{display: 'flex', borderBottom: '2px solid var(--primary-color)', flexShrink: 0}}>
                <button 
                    className={`${styles.navButton} ${sidebarTab === 'cart' ? styles.navButtonActive : ''}`} 
                    style={{flex: 1, borderRadius: '8px 8px 0 0'}}
                    onClick={() => setSidebarTab('cart')}
                >
                    <CartIcon style={{marginRight: '8px'}}/> Shopping Cart
                </button>
                <button 
                    className={`${styles.navButton} ${sidebarTab === 'draft' ? styles.navButtonActive : ''}`} 
                    style={{flex: 1, borderRadius: '8px 8px 0 0'}}
                    onClick={() => setSidebarTab('draft')}
                >
                    <DraftIcon style={{marginRight: '8px'}}/> Draft Pad
                </button>
            </div>

            {sidebarTab === 'cart' ? (
                <div style={{flex: '1', display: 'flex', flexDirection: 'column', overflow: 'hidden', paddingTop: '20px'}}>
                    <ShoppingCart
                        cart={cart}
                        onUpdateQuantity={onUpdateQuantity}
                        onRemoveItem={onRemoveItem}
                        onImageClick={onImageClick}
                        onCheckout={onCheckout}
                    />
                </div>
            ) : (
                <div style={{flex: '1', display: 'flex', flexDirection: 'column', overflow: 'hidden', paddingTop: '20px'}}>
                    <DraftItems onParseDraft={onParseDraft} />
                </div>
            )}
        </div>
    );
};